import { useState } from "react";
import {
  Box,
  VStack,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Image,
  Button,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { logout } from "../authConfig";

const menuItems = [
  { name: "Dashboard", path: "/dashboard", icon: "/svg/DashBoard.svg" },
  { name: "Requests", path: "/requests", icon: "/svg/Request.svg" },
  { name: "Jobs", path: "/job", icon: "/svg/Job.svg" },
  { name: "Approvals", path: "/approvals", icon: "/svg/Approval.svg" },
  { name: "Stock alerts", path: "/stock-alerts", icon: "/svg/stockAlert.svg" },
  { name: "Modules", path: "/modules", icon: "/svg/modules.svg" },
  { name: "News", path: "/news", icon: "/svg/news.svg" },
  {
    name: "Announcements",
    path: "/announcements",
    icon: "/svg/Announsment.svg",
  },
  { name: "Clients", path: "/clients", icon: "/svg/Client.svg" },
  { name: "Invoice List", path: "/invoice-list", icon: "/svg/Invoice.svg" },
  { name: "Profile", path: "/profile", icon: "/svg/Profile.svg" },
];

const Sidebar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname);

  return (
    <>
      {/* Sidebar for Large Screens */}
      <Box
        bg="#101828"
        color="white"
        w={{ base: "0", md: "250px" }}
        h="100vh"
        p={5}
        display={{ base: "none", md: "block" }}
        position="fixed"
      >
        <Image
          src="/Main_LOGO.png"
          alt="Paragon Logo"
          w="127px"
          h="23px"
          ml={2}
          mt={9}
          mb={10}
        />
        <VStack align="stretch" gap="0">
          {menuItems.map((item, index) => (
            <Box
              as={Link}
              to={item.path}
              key={index}
              pl={3}
              pt={3}
              pb={3}
              _hover={{ cursor: "pointer" }}
              borderRadius="md"
              textDecoration="none"
              // color="#d7d7d7"
              display="Flex"
              alignItems="center"
              fontSize="14px"
              color={activeItem === item.path ? "white" : "#d7d7d7"}
              bg={activeItem === item.path ? "transparent" : null}
              onClick={() => setActiveItem(item.path)}
            >
              <Image src={item.icon} alt={item.name} w="18px" h="18px" mr={3} />
              {item.name}
            </Box>
          ))}
        </VStack>
        <Box position="absolute" bottom="20px" left="0" width="100%" p={5}>
          <Button
            onClick={logout}
            w="100%"
            bg="red.600"
            _hover="none"
            color="white"
            borderRadius="md"
          >
            Logout
          </Button>
        </Box>
      </Box>

      {/* Hamburger Icon for Small Screens */}
      <IconButton
        icon={<FontAwesomeIcon icon={faBars} />}
        onClick={onOpen}
        display={{ base: "block", md: "none" }}
        position="fixed"
        top={4}
        left={4}
        zIndex={1000}
      />

      {/* Mobile Sidebar Drawer */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="#101828" color="white" p={5}>
          <DrawerCloseButton />

          <Image
            src="/Main_LOGO.png"
            alt="Paragon Logo"
            w="127px"
            h="23px"
            ml={2}
            mt={9}
            mb={10}
          />
          <VStack align="stretch" gap="0">
            {menuItems.map((item, index) => (
              <Box
                as={Link}
                to={item.path}
                key={index}
                pl={3}
                pt={3}
                pb={3}
                _hover={{ cursor: "pointer" }}
                borderRadius="md"
                textDecoration="none"
                color="#d7d7d7"
                display="Flex"
                alignItems="center"
                fontSize="14px"
                onClick={onClose}
              >
                <Image
                  src={item.icon}
                  alt={item.name}
                  w="18px"
                  h="18px"
                  mr={3}
                />
                {item.name}
              </Box>
            ))}
          </VStack>
          <div style={{ marginLeft: "5px", textAlign: "center" }}>
            <Box position="absolute" bottom="20px" left="0" width="100%" p={5}>
              <Button
                onClick={logout}
                w="100%"
                bg="red.600"
                _hover="none"
                color="white"
                borderRadius="md"
              >
                Logout
              </Button>
            </Box>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Sidebar;
